// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   Step 1 — Choice cards
   ================================================================ */

.lookup-subtitle {
  font-size: 0.8125rem;
  color: #6b7280;
  margin: 0.25rem 0 0;
}

.lookup-card {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1rem 1.25rem;
  margin-bottom: 0.75rem;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  background: #fff;
}

.lookup-card:hover {
  border-color: #9ca3af;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.07);
}

.lookup-card.primary {
  border-left: 3px solid #4f46e5;
}

.lookup-card.primary:hover {
  border-left-color: #4338ca;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.1);
}

.lookup-card-body {
  flex: 1;
}

.lookup-card-title {
  font-weight: 600;
  font-size: 0.9375rem;
  color: #111827;
  margin-bottom: 0.2rem;
}

.lookup-card-desc {
  font-size: 0.8125rem;
  color: #6b7280;
  line-height: 1.45;
}

.lookup-card-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}

.lookup-recommended-badge {
  display: inline-block;
  background: #ede9fe;
  color: #6d28d9;
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border-radius: 100px;
  padding: 2px 9px;
  margin-bottom: 0.5rem;
}


/* ================================================================
   Step 2 — Back button + search
   ================================================================ */

.btn-back {
  background: none;
  border: none;
  padding: 0;
  font-size: 0.8125rem;
  color: #6b7280;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  line-height: 1;
  margin-bottom: 0.25rem;
}

.btn-back:hover {
  color: #374151;
}

.section-label {
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9ca3af;
}

.lookup-hint {
  font-size: 0.75rem;
  font-style: italic;
}


/* ================================================================
   Entity results list (Attio-style)
   ================================================================ */

.entity-list {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.entity-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f3f4f6;
  transition: background 0.1s ease;
}

.entity-row:last-child {
  border-bottom: none;
}

.entity-row:hover {
  background: #f9fafb;
}

.entity-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #374151;
  font-size: 0.8125rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  -webkit-user-select: none;
          user-select: none;
}

.entity-info {
  flex: 1;
  min-width: 0;
}

.entity-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.entity-meta {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 0.1rem;
}

.entity-sep {
  margin: 0 0.25em;
  opacity: 0.35;
}

.entity-action {
  flex-shrink: 0;
}

.entity-empty {
  text-align: center;
  color: #9ca3af;
  font-size: 0.875rem;
  padding: 2rem 0;
}


/* ================================================================
   Suspension badge
   ================================================================ */

.suspension-badge {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  font-size: 0.675rem;
  font-weight: 600;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/modal-choose-federation/modal-choose-federation.component.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;;AAGA;;qEAEqE;;AAErE;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;;qEAEqE;;AAErE;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;;qEAEqE;;AAErE;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["/* ================================================================\n   Step 1 — Choice cards\n   ================================================================ */\n\n.lookup-subtitle {\n  font-size: 0.8125rem;\n  color: #6b7280;\n  margin: 0.25rem 0 0;\n}\n\n.lookup-card {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 1rem 1.25rem;\n  margin-bottom: 0.75rem;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  background: #fff;\n}\n\n.lookup-card:hover {\n  border-color: #9ca3af;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.07);\n}\n\n.lookup-card.primary {\n  border-left: 3px solid #4f46e5;\n}\n\n.lookup-card.primary:hover {\n  border-left-color: #4338ca;\n  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.1);\n}\n\n.lookup-card-body {\n  flex: 1;\n}\n\n.lookup-card-title {\n  font-weight: 600;\n  font-size: 0.9375rem;\n  color: #111827;\n  margin-bottom: 0.2rem;\n}\n\n.lookup-card-desc {\n  font-size: 0.8125rem;\n  color: #6b7280;\n  line-height: 1.45;\n}\n\n.lookup-card-action {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n.lookup-recommended-badge {\n  display: inline-block;\n  background: #ede9fe;\n  color: #6d28d9;\n  font-size: 0.625rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  border-radius: 100px;\n  padding: 2px 9px;\n  margin-bottom: 0.5rem;\n}\n\n\n/* ================================================================\n   Step 2 — Back button + search\n   ================================================================ */\n\n.btn-back {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 0.8125rem;\n  color: #6b7280;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  line-height: 1;\n  margin-bottom: 0.25rem;\n}\n\n.btn-back:hover {\n  color: #374151;\n}\n\n.section-label {\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #9ca3af;\n}\n\n.lookup-hint {\n  font-size: 0.75rem;\n  font-style: italic;\n}\n\n\n/* ================================================================\n   Entity results list (Attio-style)\n   ================================================================ */\n\n.entity-list {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.entity-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f3f4f6;\n  transition: background 0.1s ease;\n}\n\n.entity-row:last-child {\n  border-bottom: none;\n}\n\n.entity-row:hover {\n  background: #f9fafb;\n}\n\n.entity-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #e5e7eb;\n  color: #374151;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  user-select: none;\n}\n\n.entity-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.entity-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.entity-meta {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-top: 0.1rem;\n}\n\n.entity-sep {\n  margin: 0 0.25em;\n  opacity: 0.35;\n}\n\n.entity-action {\n  flex-shrink: 0;\n}\n\n.entity-empty {\n  text-align: center;\n  color: #9ca3af;\n  font-size: 0.875rem;\n  padding: 2rem 0;\n}\n\n\n/* ================================================================\n   Suspension badge\n   ================================================================ */\n\n.suspension-badge {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n  font-size: 0.675rem;\n  font-weight: 600;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
